import { Injectable } from '@angular/core';
import { ApiHttpClient, ListOption } from '../modules/tcm-core.module';
import { IcdCodeListOptionRequest } from '../models/icd-codes';
import { EarSideExtendedUnspecifiedEnum } from '../models/enums';

@Injectable({
  providedIn: 'root'
})
export class IcdCodeDataService {

  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public getIcdCodeOptionsAsync(query: string, side: EarSideExtendedUnspecifiedEnum, ignoredIds: number[], cancellationToken: Promise<any>): Promise<ListOption<number>[]> {
    const request: IcdCodeListOptionRequest = { searchString: query, icdSide: side, ignoredIds: ignoredIds };
    return this.httpClient.getJsonAsync<ListOption<number>[]>('IcdCodes/Options', request, cancellationToken);
  }
}
